export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14485.662902b1.jpg";